import { StateObservable } from 'redux-observable';
import { createOpenWithEdit, State, VariablesEditorDialogAction } from '../';
import { map } from 'rxjs/operators';

import { EpicDependencies } from '../dependencies.interface';
import { Observable } from 'rxjs';

export const fillEditDataFromApi = (
  actions$: Observable<VariablesEditorDialogAction>,
  state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<VariablesEditorDialogAction> => dependencies.edit$.pipe(map(createOpenWithEdit));
